import { createTheme } from '@mui/material';

const darkOptions = {
  palette: {
    mode: 'dark',
    primary: {
      main: '#407796', // Theme Color 1
      light: '#5a8ba8',
      dark: '#2d5a6b',
    },
    secondary: {
      main: '#CDD5E1', // Primary Grey
      light: '#e2e8f0',
      dark: '#a8b5c7',
    },
    text: {
      primary: '#FFFFFF', // Primary White
      secondary: '#CDD5E1', // Primary Grey
    },
    background: {
      default: '#000000', // Primary Black
      paper: '#101823', // Primary Dark Blue
    },
    warning: {
      main: '#EED796', // Theme Color 3
    },
    error: {
      main: '#855032', // Theme Color 2
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
  },
};

const lightOptions = {
  palette: {
    mode: 'light',
    primary: {
      main: '#407796', // Theme Color 1
      light: '#5a8ba8',
      dark: '#2d5a6b',
    },
    secondary: {
      main: '#CDD5E1', // Primary Grey
      light: '#e2e8f0',
      dark: '#a8b5c7',
    },
    text: {
      primary: '#000000', // Primary Black (reversed)
      secondary: '#101823', // Primary Dark Blue (reversed)
    },
    background: {
      default: '#FFFFFF', // Primary White (reversed)
      paper: '#F5F6F7', // Light grey (reversed from dark blue)
    },
    warning: {
      main: '#EED796', // Theme Color 3
    },
    error: {
      main: '#855032', // Theme Color 2
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
  },
};

export const createDarkTheme = (direction = 'ltr') =>
  createTheme({ ...darkOptions, direction });

export const createLightTheme = (direction = 'ltr') =>
  createTheme({ ...lightOptions, direction });

const darkTheme = createDarkTheme();
const lightTheme = createLightTheme();

export default darkTheme;
export { lightTheme, darkTheme };
